export const EssaScores = [
    { name: "Overall ESSA Score", field: "essaSchoolIndexScoreCY" },
    { name: "Weighted Achievement Score", field: "finalWeightedAchievementAdjustedFor95PctTested" },
    { name: "Value-Added Growth Score", field: "finalContentWithELPGrowthScore" },
    { name: "4-Year Graduation Rate", field: "finalFourYearGraduationRate" },
    { name: "5-Year Graduation Rate", field: "finalFiveYearGraduationRate" },
    { name: "School Quality and Student Success Score", field: "finalSQSSScore" }
];